const APP_VERSION = '1776969077141';
export default APP_VERSION;
